import { readonly, ref } from "vue";

export function useSQDCWorkflowAdvanceLock() {
  const pending = ref(false);

  async function run(advance: () => Promise<boolean>) {
    if (pending.value) return false;
    pending.value = true;
    try {
      const advanced = await advance();
      if (!advanced) pending.value = false;
      return advanced;
    } catch (error) {
      pending.value = false;
      throw error;
    }
  }

  function reset() {
    pending.value = false;
  }

  return {
    pending: readonly(pending),
    run,
    reset,
  };
}
